import React, { useRef, useCallback } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Carousel } from '../../components';
import css from './SeoPage.module.css';

const CategorySection = ({ categorySectionData = [], sectionTitle, urlParts }) => {
  const history = useHistory();
  const sliderRef = useRef();



  const handleClick = useCallback(item => {
    if (item.attributes?.urlPath) {
      const routePath = `/${urlParts?.[0] || 'en-US'}${
        item.attributes.urlPath.startsWith('/') ? '' : '/'
      }${item.attributes.urlPath}`;
      history.push(routePath);
    }
  }, [urlParts, history]);

  const handlePrev = useCallback(() => {
    if (sliderRef.current) sliderRef.current.slickPrev();
  }, []);

  const handleNext = useCallback(() => {
    if (sliderRef.current) sliderRef.current.slickNext();
  }, []);

  if (!categorySectionData || categorySectionData.length === 0) {
    return null;
  }

  return (
    <section className={css.disciplineSlider}>
      <div className={css.headerRow}>
        <h2 className={css.disciplineHeading}>{sectionTitle}</h2>
        <div className={css.carouselArrows}>
          <button className={css.arrowBtn} onClick={handlePrev} aria-label="Previous">
            ‹
          </button>
          <button className={css.arrowBtn} onClick={handleNext} aria-label="Next">
            ›
          </button>
        </div>
      </div>
      <div className={css.carouselWrapper}>
        <Carousel
          key={`category-${categorySectionData.length}-${urlParts?.[0] || 'en-US'}-${categorySectionData.map(item => item.id || item.attributes?.urlPath).join('-')}`}
          ref={sliderRef}
          columns={4}
          className={css.carousel}
          contentClassName={css.carouselContent}
          showArrows={false}
          responsive={{
            480: { columns: 1 },
            768: { columns: 2 },
            992: { columns: 3 },
            1200: { columns: 4 }
          }}
        >
          {categorySectionData.map((item, index) => {
            const { image, tag = [], section = [], urlPath } = item.attributes || {};
            

            
            // Extract title from urlPath or tags based on page type
            let title = '';
            
            if (urlPath) {
              const pathParts = urlPath.split('/').filter(Boolean);
              if (pathParts.length > 0) {
                // Use the last meaningful part of the URL
                title = pathParts[pathParts.length - 1]
                  .split('-')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' ');
              }
            }
            
            // Fallback: Use title from section or tags
            if (!title) {
              const firstSection = section[0] || {};
              title = firstSection.title || '';
              
              // If still no title, try to extract from tags
              if (!title && tag.length > 0) {
                const nameTag = tag.find(t => t.value);
                if (nameTag) {
                  title = nameTag.value.charAt(0).toUpperCase() + nameTag.value.slice(1);
                }
              }
            }



            return (
              <div key={item.id || index} className={`${css.articleSlider} ${css.sliderCard}`} onClick={() => handleClick(item)}>
                {/* Image with overlay title - same as RegionDisciplineSection but no description */}
                <div className={css.articleImage}>
                  <img 
                    src={image?.url || '/static/imgs/placeholder.jpg'} 
                    alt={title || ''} 
                    loading="lazy"
                    style={{ height: '184px', width: '100%', objectFit: 'cover' }}
                  />
                  {title && (
                    <div className={css.articleTitle}>{title}</div>
                  )}
                </div>
              </div>
            );
          })}
        </Carousel>
      </div>
    </section>
  );
};

export default CategorySection;
